import { NgModule } from '@angular/core';
import { DateInputComponent } from './date-input.component';
import { ElementsModule } from '@shared/elements/elements.module';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from '@core/core.module';
import { DirectivesModule } from '@shared/directives/directives.module';
import { TranslateModule } from '@ngx-translate/core';
import { FormValidationModule } from '@components/form-validation/form-validation.module';

@NgModule({
    imports: [
        ElementsModule,
        CommonModule,
        ReactiveFormsModule,
        CoreModule,
        DirectivesModule,
        TranslateModule,
        FormValidationModule
    ],
    exports: [
        DateInputComponent
    ],
    declarations: [
        DateInputComponent
    ]
})

export class DateInputModule {}
